<div class="layout-content">
<form (ngSubmit)="submit()" [formGroup]="multiIOForm">
  <div class="grid">
		<div class="col-12" [ngClass]="customPaddingX()">
			<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.stateActive, 'borderRow')">
				<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.stateActive, 'label')">{{ 'STATE_ACTIVE' | translate }}</div>
				<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.stateActive, 'borderInput')">
					<p-dropdown [options]="stateActiveOpt" formControlName="stateActive"
						[ngClass]="dynamicInputTextWidth()"
						styleClass="{{ dynamicInputTextWidth() }} align-items-center pl-5"
						id="edit-input-dialog-stateActive"
						placeholder="{{ 'STATE_ACTIVE' | translate }}">
						<ng-template let-item pTemplate="selectedItem">
							<div class="item flex align-items-center justify-content-center">
								<div class="flex align-items-center">{{ item.label | translate }}</div>
							</div>
						</ng-template>
						<ng-template let-item pTemplate="item">
							<div class="item flex justify-content-center">
								<div>{{item.label | translate }}</div>
							</div>
						</ng-template>
					</p-dropdown>
				</div>
			</div>
			<small *ngIf="showErrorRequiredMessage(this.f.stateActive)" class="flex align-items-center label-50 pt-1" [ngClass]="justifyMessagesNewValidator()">{{ 'REQUIRED' | translate }}</small>
		</div>
		<div [ngClass]="col12Responsive()">
			<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.activeState, 'borderRow')">
				<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.activeState, 'label')">{{ 'ACTIVE_STATE_LABEL' | translate }}</div>
				<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.activeState, 'borderInput')">
					<input type="text" pInputText
						[ngClass]="dynamicInputTextWidth()"
						formControlName="activeState"
					/>
				</div>
			</div>
			<div class="flex align-items-center text-50" [ngClass]="justifyContentStyle()">
				<small *ngIf="showErrorRequiredMessage(this.f.activeState)" class="pt-1">{{ 'REQUIRED' | translate }}</small>
				<small *ngIf="!showErrorRequiredMessage(this.f.activeState) && (!underTablet())" class="pt-1_25rem"></small>
			</div>
		</div>
		<div [ngClass]="col12Responsive()">
			<div class="flex justify-content-between flex-wrap" [ngClass]="newShowErrors(this.f.inactiveState, 'borderRow')">
				<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.inactiveState, 'label')">{{ 'INACTIVE_STATE_LABEL' | translate }}</div>
				<div class="flex align-items-center justify-content-center" [ngClass]="newShowErrors(this.f.inactiveState, 'borderInput')">
					<input type="text" pInputText
						[ngClass]="dynamicInputTextWidth()"
						formControlName="inactiveState"
					/>
				</div>
			</div>
			<div class="flex align-items-center text-50" [ngClass]="justifyContentStyle()">
				<small *ngIf="showErrorRequiredMessage(this.f.inactiveState)" class="pt-1">{{ 'REQUIRED' | translate }}</small>
				<small *ngIf="!showErrorRequiredMessage(this.f.inactiveState) && (!underTablet())" class="pt-1_25rem"></small>
			</div>
		</div>
	</div>

	<div class="grid mt-5 mb-1 mx-1 flex justify-content-center align-items-center">
		<button type="submit" pButton pRipple
			label="{{ 'CONFIRM' | translate }}"
			class="p-button-primary text-xl font-normal mx-1 mb-2"
			[ngClass]="dynamicButtonWidth()">
		</button>
		<button type="button" pButton pRipple (click)="closeDialog()"
				label="{{ 'CANCEL' | translate }}"
				class="p-button-secondary text-xl font-normal mx-1 mb-2"
				[ngClass]="dynamicButtonWidth()">
		</button>
	</div>
  </form>
</div>
